module.exports = __webpack_public_path__ + "static/media/LAZ_03.71179d8d.jpg";